<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119 nav-border-bottom">
    <div class="col-md-12">
      <div id="row" class="container pb-20">
        <div class="row">
          <div class="col-md-12">
            <div class="bg-yellow-gradient text-shadow mt-32">
              <h1 class="py-2 m-6 mt-16 mb-16 a-font-style textColor black text-shadow font-italic">Contrastaria</h1>
            </div>
          </div>
          <div class="row col-12 d-flex justify-content-center">
            <h2 class="font-italic text-white mb-5">Desde 01 de janeiro de 2021, estão em vigor as seguintes marcas de Contrastaria.</h2>
            <div class="col-md-6 col-lg-4 col-xl-12 col-12 pointer">
              <img src="{{c2021}}" class="img-fluid border-const" alt="" (click)="setSel(c2021)">
            </div>
            <a class="mt-5 h3 text-white font-decoration" href="../../assets/contrastaria/contrastaria.pdf" download>Descarregue aqui o PDF</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="backgroundColor shark base">
  <section class="container-fluid backgroundColor shark base d-flex align-items-center position-relative top-119 pt-5 pb-20 nav-border-bottom">
    <div class="col-md-12">
      <div id="row" class="container">
        <div class="row d-flex justify-content-center">
          <div class="row col-12 d-flex justify-content-center">
            <h2 class="font-italic text-white mb-5">Desde 2015 até 31 Dezembro de 2020 vigoraram as seguintes marcas legais das Contrastarias Portuguesas.</h2>
            <div class="col-md-6 col-lg-4 col-xl-12 col-12 pointer" style="display:contents;">
              <img src="{{c2015}}" class="img-fluid border-const" alt="" (click)="setSel(c2015)">
            </div>
          </div>
          <a class="mt-5 h3 text-white font-decoration" href="../../assets/contrastaria/contrastaria2015.pdf" download>Descarregue aqui o PDF</a>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119">
    <div class="col-md-12">
      <div id="row" class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="bg-yellow-gradient text-shadow">
              <h1 class="py-2 m-6 mt-16 mb-16 a-font-style textColor black">Marcas legais das Contrastarias Portuguesas ao longo do tempo</h1>
            </div>
          </div>
          <div class="row col-12 d-flex justify-content-center">
            <h2 class="font-italic text-white mb-5"></h2>
            <div class="col-md-6 col-lg-4 col-xl-12 col-12">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12 col-lg-3">
            <div class="row pb-20">
              <div class="col-12 col-md-12 col-lg-12">
                <div class="card border-const-2" id="padding-right">
                  <div class="card-body">
                    <h2 class="text-white text-center">Selecione o ano para visualizar</h2>
                  </div>
                  <ul class="list-group list-group-flush text-white text-center">
                    <a class="a-font-decoration bg-hover text-white pointer" [class.active]="c1998 == cur" (click)="swapList(c1998)"> 
                      <li class="list-group-item"><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon><span class="ml-2 mr-2"> 1998 </span><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon></li>
                    </a>
                    <a class="bg-hover a-font-decoration text-white pointer" [class.active]="c1985 == cur" (click)="swapList(c1985)">
                      <li class="list-group-item"><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon><span class="ml-2 mr-2"> 1985 </span><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon></li>
                    </a>
                    <a class="bg-hover a-font-decoration text-white pointer" [class.active]="c1938 == cur" (click)="swapList(c1938)">
                      <li class="list-group-item"><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon><span class="ml-2 mr-2"> 1938 </span><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon></li>
                    </a>
                    <a class="bg-hover a-font-decoration text-white pointer"  [class.active]="c1887 == cur" (click)="swapList(c1887)">
                      <li class="list-group-item"><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon><span class="ml-2 mr-2"> 1887 </span><fa-icon [icon]="faHorizontalRule" class="fal fa-horizontal-rule"></fa-icon></li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-9">
            <div class="col-12 backgroundColor border-const-2 base py-3 pointer" (click)="setSel(cur)">
              <img src="{{cur}}" class="img-fluid" alt="">
            </div>
            <!-- Modal -->
            <div class="modal bd-example-modal-xl" [class.fade]="!display" [class.show]="display" [class.hide]="!display">
              <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="display = false">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body d-flex justify-content-center">
                    <img src="{{sel}}" alt="">
                  </div>
                  <div class="modal-footer">
                    <div class="btn btn-outline-secondary">
                      <a class="a-font-decoration" href="{{sel}}" download>Download</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>